module.exports = __webpack_public_path__ + "assets/img/for-investors.bf7cedaf.jpg";